import React, { useState, useEffect, useRef } from 'react';
import './Services.css';
import ISE from './images/ise.png';
import ENERGIA from './images/energia.jpg';
import INFRAESTRUCTURAS from './images/infraestructura.jpg';
import REGIN from './images/REGIN.jpg';
import StreetArtDemo from './images/StreetArtDemo.mp4';
import EscaparatesDemo from './images/EscaparatesDemo.mp4';
import CervantesDemo from './images/CervantesDemo.mp4';

const Services = () => {
  const [titleVisible, setTitleVisible] = useState(false);
  const [widgetVisibility, setWidgetVisibility] = useState({
    marketing: false,
    efficiency: false,
    infrastructure: false,
  });

  const [activeVideo, setActiveVideo] = useState(null);

  const titleRef = useRef(null);
  const marketingRef = useRef(null);
  const efficiencyRef = useRef(null);
  const infrastructureRef = useRef(null);

  const videoMap = {
    Inspira: StreetArtDemo,
    Transforma: EscaparatesDemo,
    Conecta: CervantesDemo,
  };

  const handleClick = (videoKey) => {
    setActiveVideo(videoKey);
  };

  const closeVideoPage = () => {
    setActiveVideo(null);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === titleRef.current) {
            setTitleVisible(entry.isIntersecting);
          }
          if (entry.isIntersecting) {
            if (entry.target === marketingRef.current) {
              setWidgetVisibility((prevState) => ({ ...prevState, marketing: true }));
            }
            if (entry.target === efficiencyRef.current) {
              setWidgetVisibility((prevState) => ({ ...prevState, efficiency: true }));
            }
            if (entry.target === infrastructureRef.current) {
              setWidgetVisibility((prevState) => ({ ...prevState, infrastructure: true }));
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    if (marketingRef.current) observer.observe(marketingRef.current);
    if (efficiencyRef.current) observer.observe(efficiencyRef.current);
    if (infrastructureRef.current) observer.observe(infrastructureRef.current);

    return () => {
      if (titleRef.current) observer.unobserve(titleRef.current);
      if (marketingRef.current) observer.unobserve(marketingRef.current);
      if (efficiencyRef.current) observer.unobserve(efficiencyRef.current);
      if (infrastructureRef.current) observer.unobserve(infrastructureRef.current);
    };
  }, []);

  return (
    <section id="services">
      <div className="title-section">
        <h1
          className={`solutions-title ${titleVisible ? 'slide-in' : ''}`}
          ref={titleRef}
        >
          CONOCE NUESTRAS SOLUCIONES
        </h1>
      </div>

      {/* VIDEO MODAL OVERLAY */}
      {activeVideo && (
        <>
          <div className="video-modal-backdrop" onClick={closeVideoPage}></div>
          <div className="video-modal">
            <button className="back-button" onClick={closeVideoPage}>
              ← Volver a soluciones
            </button>
            <h2>{activeVideo}</h2>
            <video
              src={videoMap[activeVideo]}
              controls
              autoPlay
              style={{ width: '100%', maxHeight: '80vh', borderRadius: '12px' }}
            />
          </div>
        </>
      )}

      {/* SERVICE CONTENT */}
      <div className="services-content">
        <div className={`widget ${widgetVisibility.marketing ? 'fade-in' : ''}`} ref={marketingRef}>
          <h2>MARKETING DIGITAL</h2>
          <div className="marketing-widgets">
            <div className="marketing-widget widget-blue1" onClick={() => handleClick('Inspira')}>
              <h3>Inspira</h3>
              <p>Estrategias creativas para captar la atención de tus clientes desde el primer contacto.</p>
              <span className="click-hint">Descubre los murales vivos...</span>
            </div>
            <div className="marketing-widget widget-blue2" onClick={() => handleClick('Transforma')}>
              <h3>Transforma</h3>
              <p>Optimiza tu presencia digital con soluciones que convierten visitas en resultados.</p>
              <span className="click-hint">Conoce los escaparates interactivos...</span>
            </div>
            <div className="marketing-widget widget-blue3" onClick={() => handleClick('Conecta')}>
              <h3>Conecta</h3>
              <p>Fortalece la relación con tu audiencia a través de experiencias interactivas.</p>
              <span className="click-hint">¿Conoces a Cervantes?...</span>
            </div>
          </div>
        </div>

        <div className={`widget ${widgetVisibility.efficiency ? 'fade-in' : ''}`} ref={efficiencyRef}>
          <h2 className="tenergia">EFICIENCIA ENERGÉTICA</h2>
          <div className="efficiency-content">
            <img src={ENERGIA} alt="ENERGIA" className="energia-img" />
            <div className="more-info-e">
              <p>
                CUALO ofrece ISE, una potente Solución para la Gestión de la Eficiencia Energética (EMS) a la medida del cliente,
                diseñada para integrarse en cualquier edificio o infraestructura en cualquier parte del mundo.
              </p>
              <p>
                Almacena datos de consumo energético, variables externas (temperatura, ocupación) y proporciona análisis avanzado
                y reporting para optimizar la gestión energética.
              </p>
              <img src={ISE} alt="ISE" className="efficiency-img" />
            </div>
          </div>
        </div>

        <div className={`widget ${widgetVisibility.infrastructure ? 'fade-in' : ''}`} ref={infrastructureRef}>
          <h2>INFRAESTRUCTURAS INTELIGENTES</h2>
          <div className="infrastructure-content">
            <div className="more-info-i">
              <p>
                CUALO aporta una visión moderna para la Gestión de Infraestructuras Inteligentes (BMS), dándole el control
                al propietario y reduciendo dependencia de fabricantes.
              </p>
              <p>
                Colaboramos con Regin en la modernización de sistemas de gestión de edificios e infraestructuras.
              </p>
              <img src={REGIN} alt="REGIN" className="infrastructure-img" />
            </div>
            <a href="https://www.regincontrols.com/es/es/" target="_blank" rel="noopener noreferrer">
              <img src={INFRAESTRUCTURAS} alt="INFRAESTRUCTURA" className="infra-img" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
